/**
 * 接入GA（google analytics）统计
 */

const SUISHOUJI_ID = 'UA-251384-16'
const GA_URL = 'https://ssl.google-analytics.com/ga.js'

// 接入GA
const insert = () => {
  window._gaq = window._gaq || []
  window._gaq.push(['_setAccount', SUISHOUJI_ID])
  window._gaq.push(['_trackPageview'])

  const ga = document.createElement('script')
  ga.type = 'text/javascript'
  ga.async = true
  ga.src = GA_URL
  document.body.appendChild(ga)
}

export default () => {
  setTimeout(insert, 0) // 避免加载阻断其他JS不执行
}


// WEBPACK FOOTER //
// ./node_modules/@common/collect/src/lib/ga.js